module.exports = __webpack_public_path__ + "media/images/doctor-74c980e79d6ffed01e52959065897d20.png";